/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Spec_Platforms_ValueInputs */

const en_fc_home_spec_platforms_value = /** @type {(inputs: Fc_Home_Spec_Platforms_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS, Windows, Linux, FreeBSD, Web`)
};

/**
* | output |
* | --- |
* | "macOS, Windows, Linux, FreeBSD, Web" |
*
* @param {Fc_Home_Spec_Platforms_ValueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_spec_platforms_value = /** @type {((inputs?: Fc_Home_Spec_Platforms_ValueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Spec_Platforms_ValueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_spec_platforms_value(inputs)
});
export { fc_home_spec_platforms_value as "fc.home.spec.platforms_value" }